import { SmsFailedRounded, SmsRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { parseISO, sub } from 'date-fns';
import React from 'react';
import { theme } from '../../theme';
import { useNavigate } from 'react-router';

function MobilePhoneStatus({ physician, clickable = true }) {
    const navigate = useNavigate();

    function getStyling() {
        if (physician.do_not_text === true) {
            return { 
                color: theme.palette.red.main,
                title: 'Physician is set to Do Not Text'
            };
        } else if (!physician.phone_number_lookup) {
            return { 
                color: theme.palette.subtext.main,
                title: 'Phone number not validated'
            };
        } else if (!physician.phone_number_lookup.is_valid) {
            return { 
                color: theme.palette.red.main,
                title: 'Phone number not validated as ' + physician.phone_number_lookup.line_type
            };
        } else if (physician.phone_number_lookup.is_valid && parseISO(physician.phone_number_lookup.last_validated_at) < sub(Date.now(), { years: 1 })) {
            return { 
                color: theme.palette.warning.main,
                title: 'Phone number validated as Mobile (Last validated over 1 year ago)'
            };
        }
        return { 
            color: theme.palette.success.main,
            title: 'Phone number validated as Mobile'
        };
    }

    function handleClick(event) {
        event.stopPropagation();
        navigate(`/physicians/${physician.id}/physicianTexting`);
    }

    if (!physician.phone_number_lookup?.is_valid || physician.do_not_text === true) {
        if (!clickable) {
            return <SmsFailedRounded
                style={{
                    color: getStyling().color,
                }}
                titleAccess={getStyling().title}
            />;
        }
        return (
            <IconButton onClick={handleClick}>
                <SmsFailedRounded
                    style={{
                        color: getStyling().color,
                    }}
                    titleAccess={getStyling().title}
                />
            </IconButton>
        )
    }

    if (clickable) { 
        return <IconButton onClick={handleClick}>
            <SmsRounded
                style={{
                    color: getStyling().color,
                }}
                titleAccess={getStyling().title}
            />
        </IconButton>;
    }

    return <SmsRounded
        style={{
            color: getStyling().color,
        }}
        titleAccess={getStyling().title}
    />;
}

export default MobilePhoneStatus;
